'use client';
import React, { useCallback, useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import Notification from '@/component/Notification';
import { LeadButtonProps } from '../../../app/utilities/interfaces';
import { acquireModalSession, releaseModalSession, subscribeModalSession } from '@/lib/client/modalSession';
import ContactSupportLeadModal from './ContactSupportLeadModal';
import { requestMobileLeadKeyboardForNextForm } from './LeadForm';

const CONTACT_SUPPORT_MODAL_SESSION_ID = 'contact-support-lead-modal';


const  LeadButton: React.FC<LeadButtonProps> = ({ btnText, title, fullWidth, className }) => {
    const [showModal, setShowModal] = useState(false);
    const [notification, setNotification] = useState<{
        message: string;
        isError: boolean;
        visible: boolean;
    }>({
        message: '',
        isError: false,
        visible: false,
    });

    const closeModal = useCallback(() => {
        setShowModal(false);
        releaseModalSession(CONTACT_SUPPORT_MODAL_SESSION_ID);
    }, []);

    const openModal = () => {
        requestMobileLeadKeyboardForNextForm();
        flushSync(() => {
            acquireModalSession(CONTACT_SUPPORT_MODAL_SESSION_ID);
            setShowModal(true);
        });
    };

    useEffect(() => {
        const unsubscribe = subscribeModalSession((activeId) => {
            if (activeId !== CONTACT_SUPPORT_MODAL_SESSION_ID) {
                setShowModal(false);
            }
        });

        return unsubscribe;
    }, []);

    useEffect(() => {
        return () => releaseModalSession(CONTACT_SUPPORT_MODAL_SESSION_ID);
    }, []);

    // Central notification handler
    const showNotification = (message: string, isError = false) => {
        setNotification({ message, isError, visible: true });
        setTimeout(() => {
            setNotification((prev) => ({ ...prev, visible: false }));
        }, 3000);
    };

    const handleLeadSubmit = () => {
        closeModal();
    };

    return (
        <>
            <button
                data-testid="car-lead-cta-button"
                onClick={openModal}
                title={title || (typeof btnText === "string" ? btnText : undefined)}
                className={
                    className
                        ? className
                        : `${fullWidth ? 'w-full' : 'w-1/2'} border-2 text-automotive-red card-btn font-semibold cursor-pointer transition duration-500 ease-in-out hover:text-white py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500`
                }
            >
                {btnText}
            </button>

            <ContactSupportLeadModal
                showModal={showModal}
                onClose={closeModal}
                onSubmit={handleLeadSubmit}
                onError={(msg) => showNotification(msg, true)}
            />

            <Notification
                message={notification.message}
                isVisible={notification.visible}
                isError={notification.isError}
            />
        </>
    );
};

export default LeadButton;
